import React from 'react';
import Partners from './common/Partners';

const Footer = () => {
  return (
    <footer className="p-2.5  bg-white dark:bg-darkPanelBg">
      <Partners />
      <div className="px-3 py-5">
        <div>
          <img className="w-[300px] h-auto dark:hidden" src="/images/footerlogo.svg" alt="" />
          <img className="w-[300px] h-auto hidden dark:block" src="/images/footerlogo-dark.svg" alt="" />
        </div>
        <p className="text-[#797979] text-sm leading-[21px] font-semibold mt-[14px]">
          By players for players! We offer a huge variety of slots and casino games. All of our
          slotmachines are RTP certified. Gamble Responsibly. 18+
        </p>
        <p className="text-[#fbac40] text-sm leading-[21px] font-semibold mt-[14px]">
          100% SAFE Protected connection and encrypted data.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
